import { SchemaPropertyNode } from "../../../../components/SchemaPropertyNode";
import { Observable } from "rxjs/Observable";
import { UUID } from "angular2-uuid";

export class EntityInstanceNode {
    value: any;
    propName: string;
    propType: string;
    nodeLevel: number = 0;
    isRequired: boolean = false;
    properties: EntityInstanceNode[] = [];
    schema: any;
    isExpanded: boolean = true;
    isHidden: boolean;
    isEdit: boolean;    
    setIsEditFlag(state: boolean) {
        this.isEdit = state;
        this.properties.forEach(item => item.setIsEditFlag(state));
    }
    isReadonly() {
        return (this.nodeLevel === 1 && this.propName === "type") || (this.nodeLevel === 1 && this.propName === "id");
    }



    setExpanded() {
        this.isExpanded = !this.isExpanded;
    }
    toggleExpand(state: boolean) {
        this.isHidden = state;
        this.isExpanded = !state;
        this.properties.forEach(item => item.toggleExpand(state));
    }
    isNotScalar() {
        return (this.propType === "object" || this.propType === "array");
    }
    isRootNode() {
        return this.nodeLevel === 0;
    }
    isBoolean() {
        return this.propType === "boolean";
    }
    isArray() {
        return this.propType === "array";
    }
    
    generateInstanceNodeFromSchema(schema: any) {
        this.propName = schema["title"];
        this.propType = schema["type"];
        this.isRequired = true;
        this.schema = schema;
        for (let prop in schema.properties) {
            let entityNode = this.visitSchemaNode(prop, schema.properties[prop], this.nodeLevel + 1, this.isEdit);
            entityNode.isRequired = schema["required"] && schema["required"].indexOf(prop) > -1;
            if (entityNode.propName === "type") {
                entityNode.value = schema["title"];
            }
            this.properties.push(entityNode);
        }

    }
    addInstanceNodeFromSchema(propName: string, schema: any) {
        this.properties.push(this.visitSchemaNode(propName, schema, this.nodeLevel + 1, this.isEdit));
    }
    private visitSchemaNode(propName: string, schemaObj: any, nodeLevel: number, isEdit: boolean): EntityInstanceNode {
        let entityObject: EntityInstanceNode = new EntityInstanceNode();
        if (schemaObj["type"] === "object") {
            for (let prop in schemaObj.properties) {
                let entityNode = this.visitSchemaNode(prop, schemaObj.properties[prop], nodeLevel + 1, isEdit);
                entityNode.isRequired = schemaObj["required"] && schemaObj["required"].indexOf(prop) > -1;
                entityObject.properties.push(entityNode);
            }
        }
        entityObject.propType = schemaObj["type"];
        entityObject.propName = propName;
        entityObject.schema = schemaObj;
        entityObject.nodeLevel = nodeLevel;
        entityObject.isEdit = isEdit;
        if (!entityObject.isEdit && entityObject.nodeLevel === 1 && entityObject.propName === "id") {
            entityObject.value = UUID.UUID();
        }
        return entityObject;

    }
    getEntityInstanceJson() {
        let jsonObj: any;
        if (this.propType === "object") {
            jsonObj = {};
            this.properties.forEach(prop => jsonObj[prop.propName] = prop.getEntityInstanceJson());
            return jsonObj;
        }
        if (this.propType === "array") {
            jsonObj = [];
            this.properties.forEach(item => jsonObj.push(item.getEntityInstanceJson()));
            return jsonObj;
        }
        return this.value;
    }

    importEntityInstanceNodeFromJsonObject(jsonObject: any) {

        if (jsonObject) {
            if (jsonObject.constructor == Array) {
                let listOfArrayItem = [];
                jsonObject.forEach(item => {
                    let index = this.properties.length;
                    this.addInstanceNodeFromSchema(this.properties.length.toString(), this.schema["items"][0]);
                    let arrItem = this.properties.find(item => item.propName === index.toString());
                    listOfArrayItem.push(arrItem.importEntityInstanceNodeFromJsonObject(item))
                })

            }
            else if (jsonObject.constructor === Object) {

                for (let objKey in jsonObject) {
                    let propNode = this.properties.find(item => item.propName.toLowerCase() === objKey.toLowerCase());
                    if (propNode) {
                        propNode.importEntityInstanceNodeFromJsonObject(jsonObject[objKey]);
                    }
                }
            }
            else {
                if (!(this.isEdit && this.nodeLevel === 1 && (this.propName.toLowerCase() === "id" || this.propName.toLowerCase() === "type"))) {
                    this.value = jsonObject;
                }
            }


        }

    }
}